webpackJsonp([38],{

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/**
 * 存储localStorage
 */
var setStore = function setStore(name, content) {
  if (!name) return;
  if (typeof content !== 'string') {
    content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
var getStore = function getStore(name) {
  if (!name) return;
  var obj = window.localStorage.getItem(name);
  switch (name) {
    case "userInfo":
      return JSON.parse(localStorage.getItem(name) || '{}');
    case "buyCart":
      return JSON.parse(localStorage.getItem(name) || '[]');

    default:
      return obj;
  }
};

/**
 * 删除localStorage
 */
var removeStore = function removeStore(name) {
  if (!name) return;
  window.localStorage.removeItem(name);
};

/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_message_box__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_message_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_message_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_notification__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_loading__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_rate__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_rate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_rate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dialog__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_step__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_step___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_step__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_steps__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_steps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_steps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_autocomplete__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_image__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_icon__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_checkbox__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_pagination__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_button__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_card__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_tree__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_tree___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_tree__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_collapse_item__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_collapse_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_collapse_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_collapse__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_form_item__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_form_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_form_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_cascader__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_cascader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_cascader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_form__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_backtop__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_backtop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_element_ui_lib_backtop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_element_ui_lib_upload__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_element_ui_lib_tag__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_element_ui_lib_cascader_panel__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_element_ui_lib_cascader_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_element_ui_lib_cascader_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_babel_polyfill__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__App__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__router__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__store___ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__theme_index_css__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__theme_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__theme_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vue_lazyload__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vue_infinite_scroll__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vue_cookie__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__api__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__utils_storage__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_vue_content_placeholders__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__assets_icon_iconfont_css__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__assets_icon_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__assets_icon_iconfont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_vuescroll__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_vuescroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_vuescroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_vuescroll_dist_vuescroll_css__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_vuescroll_dist_vuescroll_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_vuescroll_dist_vuescroll_css__);














































 //引入vuescroll
 //引入vuescroll样式

__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_43_vuescroll___default.a); //使用
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_29_element_ui_lib_cascader_panel___default.a);

__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_28_element_ui_lib_tag___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_27_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_41_vue_content_placeholders__["default"]);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_26_element_ui_lib_backtop___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_form___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_cascader___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_form_item___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_collapse___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_collapse_item___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_tree___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_card___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_checkbox___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_icon___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_image___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_autocomplete___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_steps___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_step___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dialog___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_rate___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_loading___default.a.directive);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].prototype.$loading = __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_loading___default.a.service;
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].prototype.$notify = __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_notification___default.a;
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].prototype.$message = __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default.a;
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].prototype.$confirm = __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_message_box___default.a.confirm;
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_37_vue_infinite_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_38_vue_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_36_vue_lazyload__["a" /* default */], {
  // preLoad: 1.3,
  // error: 'dist/error.png',
  loading: '/static/images/load.gif'
  // attempt: 1
});
__WEBPACK_IMPORTED_MODULE_31_vue__["default"].config.productionTip = false;
var whiteList = ['/home', '/goods', '/login', '/register', '/goodsDetails', '/thanks', '/search', '/refreshsearch', '/refreshgoods']; // 不需要登陆的页面

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_31_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_34__store___["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_33__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_32__App___default.a);
  }
});

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export baseURL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_storage__ = __webpack_require__(112);





// import toLogin from './login'
var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  transformRequest: [function (data) {
    data = __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify(data);
    return data;
  }],
  // www.yjlive.cn
  // baseURL: "http://rfmall.thanks.echosite.cn/",
  baseURL: "http://www.zkcxshopping.com/web/",
  // baseURL: "http://localhost:83/web/",
  withCredentials: true,
  timeout: 30000
});
var baseURL = function baseURL() {
  // return "http://rfmall.thanks.echosite.cn/";
  return "http://www.zkcxshopping.com/web/";
  // return "http://localhost:83/web/";
};
// instance.defaults.withCredentials = true;
instance.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
var defaultOpt = { login: true };
var methodsToken = ["user.info", "user.editinfo", "user.changeavatar", "user.logout", "user.addgoodsbrowsing", "user.delgoodsbrowsing", "user.goodsbrowsing", "user.goodscollection", "user.goodscollectionlist", "user.vuesaveusership", "user.saveusership", "user.getshipdetail", "user.setdefship", "user.editship", "user.removeship", "user.getusership", "api/wxpay/user.pay", "user.orderevaluate", "user.getuserdefaultship", "user.issign", "user.sign", "user.mypoint", "user.userpointlog", "user.getbankcardlist", "user.getdefaultbankcard", "user.addbankcard", "user.removebankcard", "user.setdefaultbankcard", "user.getbankcardinfo", "user.editpwd", "user.forgotpwd", "user.recommend", "user.balancelist", "user.sharecode", "user.cash", "user.cashlist", "user.myinvite", "user.activationinvite", "coupon.getcoupon", "coupon.usercoupon", "cart.add", "cart.del", "cart.getlist", "cart.setnums", "cart.getnumber", "order.cancel", "order.del", "order.details", "order.confirm", "order.getlist", "order.create", "submitPreview", "order.getship", "order.getorderlist", "order.getorderstatusnum", "order.aftersaleslist", "order.aftersalesinfo", "order.aftersalesstatus", "order.addaftersales", "order.sendreship", "order.iscomment", "payments.getinfo", "user.getuserpoint", "coupon.getcouponkey", "store.isclerk", "store.storeladinglist", "store.ladinginfo", "store.lading", "store.ladingdel", "distribution_center-api-info", "distribution_center-api-applydistribution", "distribution_center-api-setstore", "distribution_center-api-myorder", "pintuan.pintuanteam", "lottery-api-getLotteryConfig", "lottery-api-lottery", "lottery-api-lotteryLog"];

function baseRequest(options) {
  var token = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_storage__["a" /* getStore */])('token');
  var headers = options.headers || {};

  headers["Accept"] = "application/json";
  headers["Content-Type"] = "application/x-www-form-urlencoded";
  headers["authorization"] = token;
  headers["storeid"] = 2;
  options.headers = headers;
  if (options.login && !token) {
    //   toLogin();
    //  return Promise.reject({ msg: "未登录", toLogin: true });
  }
  var url = options.url.substring(1, options.url.length);
  // 判断token是否存在
  if (methodsToken.indexOf(url) >= 0) {
    if (!token) {
      // this.$router.push({path: '/page/Login/login'})
      //  toLogin();
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject({ msg: "未登录", toLogin: true });
    } else {
      //data.authorization = userToken;
    }
  }

  return instance(options).then(function (res) {
    var data = res.data || {};
    if (res.status !== 200) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject({ msg: "请求失败", res: res, data: data });

    if ([410000, 410001, 410002, 100].indexOf(data.status) !== -1) {
      // this.$router.push({path: '/page/Login/login'})
      // toLogin();
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject({ msg: res.data.msg, res: res, data: data, toLogin: true });
    } else if (data.code === 200) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(data, res);
    } else {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject({ msg: res.data.msg, res: res, data: data });
    }
  });
}

/**
 * http 请求基础类
 * 参考文档 https://www.kancloud.cn/yunye/axios/234845
 *
 */
var request = ["post", "put", "patch"].reduce(function (request, method) {
  /**
   *
   * @param url string 接口地址
   * @param data object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */

  request[method] = function (url, data) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return baseRequest(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ url: url, data: data, method: method }, defaultOpt, options));
  };
  return request;
}, {});

["get", "delete", "head"].forEach(function (method) {
  /**
   *
   * @param url string 接口地址
   * @param params object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = function (url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return baseRequest(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ url: url, params: params, method: method }, defaultOpt, options));
  };
});

/* harmony default export */ __webpack_exports__["a"] = (request);

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return userLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return smsLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return updatePawd; });
/* unused harmony export loginOut */
/* unused harmony export userInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return checkPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return userSms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return regCheckCms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return register; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return checkCaptcha; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return regCaptcha; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return regCheckCaptcha; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return memberTagList; });
/* unused harmony export upload */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateheadimage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return thanksList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return productHome; });
/* unused harmony export navList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return recommend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return thank; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return geetest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__public__ = __webpack_require__(234);


// 登陆
var userLogin = function userLogin(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/user.login', params);
};
// 手机验证码登录
var smsLogin = function smsLogin(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/user.smslogin', params);
};
// 重置密码
var updatePawd = function updatePawd(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/updatePassword', params);
};

// 退出登陆
var loginOut = function loginOut(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/user.logout', params);
};
// 用户信息
var userInfo = function userInfo(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/user.info', params);
};
// 检查手机号是否注册
var checkPhone = function checkPhone(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/user.checkphone', params);
};
// 获取手机短信验证码，并且发送短信（通过传递指定类型的短信模板来控制）
var userSms = function userSms(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/user.sms', params);
};

// 验证手机验证码
var regCheckCms = function regCheckCms(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/user.check_sms', params);
};

// 注册账号
var register = function register(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/api/member/reg.info', params);
};
// 验证图形验证码
var checkCaptcha = function checkCaptcha(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/api/member/check_captcha', params);
};
var regCaptcha = function regCaptcha(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/api/member/reg.captcha', params);
};
// 注册，验证图形验证码
var regCheckCaptcha = function regCheckCaptcha(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/api/member/reg.check_captcha', params);
};
// 商城标签
var memberTagList = function memberTagList(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/api/memberTag/list', params);
};

// 上传图片
var upload = function upload(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/api/upload', params);
};
// 修改头像
var updateheadimage = function updateheadimage(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/user.editinfo', params);
};
// 捐赠列表
var thanksList = function thanksList(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/api/member/thanks', params);
};
// 首页接口
var productHome = function productHome(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/pc.getpageconfig', params);
};
// 首页接口
var navList = function navList(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/home.navlist', params);
};
// 推荐板块
var recommend = function recommend(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/hotProductList/list', params);
};
// 捐赠板块
var thank = function thank(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/api/goods/thank', params);
};
// 获取验证码
var geetest = function geetest(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/api/member/geetestInit', params);
};

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(588);


var Index = function Index() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 625));
};
var Login = function Login() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 604));
};
var Register = function Register() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 605));
};
var Home = function Home() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 603));
};
var GoodS = function GoodS() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 599));
};
var goodsDetails = function goodsDetails() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 600));
};

var gifts = function gifts() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 598));
};
var giftsDetails = function giftsDetails() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 597));
};

var recommend = function recommend() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 612));
};

var helpDetails = function helpDetails() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 602));
};
var gotoHelp = function gotoHelp() {
  return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 601));
};

var Cart = function Cart() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 595));
};
var order = function order() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 607));
};
var user = function user() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 624));
};
var orderList = function orderList() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 621));
};
var information = function information() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 620));
};
var addressList = function addressList() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 617));
};
var coupon = function coupon() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 619));
};
var aihuishou = function aihuishou() {
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 618));
};
var support = function support() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 623));
};
var checkout = function checkout() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 596));
};
var payment = function payment() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 608));
};
var paysuccess = function paysuccess() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 609));
};
var Thanks = function Thanks() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 616));
};
var Search = function Search() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 615));
};
var RefreshSearch = function RefreshSearch() {
  return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 614));
};
var RefreshGoods = function RefreshGoods() {
  return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 613));
};
var orderDetail = function orderDetail() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 622));
};
var Alipay = function Alipay() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 606));
};
var Wechat = function Wechat() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 611));
};
var QQpay = function QQpay() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 610));
};

var Subject = function Subject() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 631));
};
var SubDetail = function SubDetail() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 629));
};
var SubGotoDetail = function SubGotoDetail() {
  return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 630));
};

var B2bCallback = function B2bCallback() {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 626));
};
var B2cCallback = function B2cCallback() {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 627));
};
var PayCallback = function PayCallback() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 628));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    component: Index,
    name: 'index',
    redirect: '/home',
    children: [{ path: 'home', component: Home }, { path: 'goods', component: GoodS }, { path: 'goodsDetails', name: 'goodsDetails', component: goodsDetails }, { path: 'gifts', component: gifts }, { path: 'giftsDetails', component: giftsDetails }, { path: 'thanks', name: 'thanks', component: Thanks }, { path: '/refreshgoods', name: 'refreshgoods', component: RefreshGoods }, { path: 'cart', name: 'cart', component: Cart }, { path: 'checkout', name: 'checkout', component: checkout }, { path: 'helpDetails', name: 'helpDetails', component: helpDetails }, { path: 'gotoHelp', name: 'gotoHelp', component: gotoHelp }, { path: 'subject', name: 'subject', component: Subject }, { path: 'subDetail', name: 'subDetail', component: SubDetail }, { path: 'subGotoDetail', name: 'subGotoDetail', component: SubGotoDetail }, { path: 'recommend', name: 'recommend', component: recommend }, { path: 'paysuccess', name: 'paysuccess', component: paysuccess, meta: { allowBack: false } }, { path: 'payment', name: 'payment', component: payment, meta: { allowBack: false } }, { path: '/search', name: 'search', component: Search }, { path: 'alipay', name: 'alipay', component: Alipay }, { path: 'wechat', name: 'wechat', component: Wechat }, { path: 'qqpay', name: 'qqpay', component: QQpay }]
  },
  // {
  //   path: '/goods', 
  //   name: 'goods',
  //   component: GoodS
  // },
  // {
  //   path: '/goodsDetails', 
  //   name: 'goodsDetails',
  //   component: goodsDetails
  // },
  // {
  //   path: '/thanks', 
  //   name: 'thanks',
  //   component: Thanks
  // },
  // {
  //   path: '/refreshgoods', 
  //   name: 'refreshgoods',
  //   component: RefreshGoods
  // },
  { path: '/b2c/pay/callback', name: 'b2c/pay/callback', component: B2cCallback }, { path: '/b2b/pay/callback', name: 'b2b/pay/callback', component: B2bCallback }, { path: '/pay/callback', name: 'pay/callback', component: PayCallback }, { path: '/login', name: 'login', component: Login }, { path: '/register', name: 'register', component: Register },
  // {path: '/cart', name: 'cart', component: Cart},
  { path: '/refreshsearch', name: 'refreshsearch', component: RefreshSearch }, {
    path: '/order',
    name: 'order',
    component: order,
    children: []
  }, {
    path: '/user',
    name: 'user',
    component: user,
    redirect: '/user/orderList',
    children: [{ path: 'orderList', name: '订单列表', component: orderList }, { path: 'orderDetail', name: '订单详情', component: orderDetail }, { path: 'information', name: '账户资料', component: information }, { path: 'addressList', name: '收货地址', component: addressList }, { path: 'coupon', name: '我的优惠', component: coupon }, { path: 'support', name: '售后服务', component: support }, { path: 'aihuishou', name: '以旧换新', component: aihuishou }]
  }, { path: '*', redirect: '/home' }],
  // base: '/pc/',
  mode: 'history', //后端支持可开
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  }
}));

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action__ = __webpack_require__(285);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

var state = {
  login: false, // 是否登录
  userInfo: null, // 用户信息
  cartList: [], // 加入购物车列表
  showMoveImg: false, // 显示飞入图片
  elLeft: 0,
  elTop: 0,
  moveImgUrl: null,
  cartPositionT: 0, // 购物车位置
  cartPositionL: 0,
  receiveInCart: false, // 是否进入购物车
  showCart: false // 是否显示购物车
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  state: state,
  action: __WEBPACK_IMPORTED_MODULE_3__action__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
}));

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INIT_BUYCART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GET_USERINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RESET_USERINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RECORD_USERINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_ANIMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SHOW_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REDUCE_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EDIT_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOGOUT; });
var INIT_BUYCART = 'INIT_BUYCART';
var ADD_CART = 'ADD_CART';
var GET_USERINFO = 'GET_USERINFO';
var RESET_USERINFO = 'RESET_USERINFO';
var RECORD_USERINFO = 'RECORD_USERINFO';
var ADD_ANIMATION = 'ADD_ANIMATION';
var SHOW_CART = 'SHOW_CART';
var REDUCE_CART = 'REDUCE_CART';
var EDIT_CART = 'EDIT_CART';
var LOGOUT = 'LOGOUT';

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_storage__ = __webpack_require__(112);



var _INIT_BUYCART$ADD_CAR;



/* harmony default export */ __webpack_exports__["a"] = (_INIT_BUYCART$ADD_CAR = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* INIT_BUYCART */], function (state) {
  var initCart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* getStore */])('buyCart');
  if (initCart) {
    state.cartList = initCart; //JSON.parse(initCart)
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* ADD_CART */], function (state, _ref) {
  var productId = _ref.productId,
      price = _ref.price,
      productName = _ref.productName,
      productPic = _ref.productPic,
      _ref$quantity = _ref.quantity,
      quantity = _ref$quantity === undefined ? 1 : _ref$quantity,
      productSkuId = _ref.productSkuId,
      productAttr = _ref.productAttr;

  var cart = state.cartList; // 购物车
  var falg = true;
  var goods = {
    productId: productId,
    price: price,
    productName: productName,
    productPic: productPic,
    productSkuId: productSkuId,
    productAttr: productAttr
  };
  if (cart.length) {
    // 有内容
    cart.forEach(function (item) {
      if (item.productId === productId && item.productSkuId === productSkuId) {
        if (item.quantity >= 0) {
          falg = false;
          item.quantity += quantity;
        }
      }
    });
  }
  if (!cart.length || falg) {
    goods.quantity = quantity;
    goods.checked = '1';
    goods.productSkuId = productSkuId;
    goods.productAttr = productAttr;
    goods.productName = productName;
    goods.productPic = productPic;
    cart.push(goods);
  }
  state.cartList = cart;
  // 存入localStorage
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('buyCart', cart);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* ADD_ANIMATION */], function (state, _ref2) {
  var moveShow = _ref2.moveShow,
      elLeft = _ref2.elLeft,
      elTop = _ref2.elTop,
      img = _ref2.img,
      cartPositionT = _ref2.cartPositionT,
      cartPositionL = _ref2.cartPositionL,
      receiveInCart = _ref2.receiveInCart;

  state.showMoveImg = moveShow;
  if (elLeft) {
    state.elLeft = elLeft;
    state.elTop = elTop;
  }
  state.moveImgUrl = img;
  state.receiveInCart = receiveInCart;
  if (cartPositionT) {
    state.cartPositionT = cartPositionT;
    state.cartPositionL = cartPositionL;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* SHOW_CART */], function (state, _ref3) {
  var showCart = _ref3.showCart;

  // let timer = null
  state.showCart = showCart;
  // clearTimeout(timer)
  // if (showCart) {
  //   timer = setTimeout(() => {
  //     state.showCart = false
  //   }, 5000)
  // }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* LOGOUT */], function (state) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["c" /* removeStore */])('token');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["c" /* removeStore */])('userInfo');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["c" /* removeStore */])('buyCart');
  state.userInfo = null;
  state.login = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* REDUCE_CART */], function (state, _ref4) {
  var productId = _ref4.productId;

  var cart = state.cartList;
  cart.forEach(function (item, i) {
    if (item.productId === productId) {
      if (item.productNum > 1) {
        item.productNum--;
      } else {
        cart.splice(i, 1);
      }
    }
  });
  state.cartList = cart;
  // 存入localStorage
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('buyCart', state.cartList);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* EDIT_CART */], function (state, _ref5) {
  var productId = _ref5.productId,
      productSkuId = _ref5.productSkuId,
      quantity = _ref5.quantity,
      checked = _ref5.checked;

  var cart = state.cartList;
  if (quantity && quantity > 0) {
    cart.forEach(function (item, i) {
      if (item.productId === productId && item.productSkuId === productSkuId) {
        item.quantity = quantity;
        item.checked = checked;
      }
    });
  } else if (productId) {
    cart.forEach(function (item, i) {
      if (item.productId === productId && item.productSkuId === productSkuId && quantity == 0) {
        cart.splice(i, 1);
      }
    });
  } else {
    cart.forEach(function (item) {
      item.checked == checked ? '1' : '0';
    });
  }
  state.cartList = cart;
  // 存入localStorage
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('buyCart', state.cartList);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* RECORD_USERINFO */], function (state, info) {
  if (info != null && info.username != null && info.username != "") {
    state.userInfo = info;
    state.login = true;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('userInfo', info);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* RESET_USERINFO */], function (state) {
  var userInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* getStore */])("userInfo");
  if (userInfo && userInfo.username != null && userInfo.username != "") {
    state.userInfo = userInfo;
    state.login = true;
    state.token = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* getStore */])('token');
  } else {
    state.userInfo = null;
    state.login = false;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* GET_USERINFO */], function (state, info) {
  if (state.userInfo && state.userInfo.username != info.username) {
    return;
  }
  if (!state.login) {
    return;
  }
  if (!info.message) {
    state.userInfo = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, info);
    state.login = true;
  } else {
    state.userInfo = null;
  }
}), _INIT_BUYCART$ADD_CAR);

/***/ }),

/***/ 563:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 565:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 567:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(567)
}
var Component = __webpack_require__(233)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(587),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 587:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    staticClass: "main"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(158);
module.exports = __webpack_require__(232);


/***/ })

},[591]);


// WEBPACK FOOTER //
// static/js/app.0df6919fef5185424e6d.js